<script>
export default {
  props: {
    closeModal: { type: Function, required: true },

    title: { type: String, default: 'Are you sure?' },
    description: { type: String },
    buttonYesText: { type: String, default: 'Yes' },
    buttonNoText: { type: String, default: 'Cancel' },
    buttonYesAction: { type: [String, Number, Boolean], default: true },
    buttonNoAction: { type: [String, Number, Boolean], default: false },
    showCheckbox: { type: Boolean, default: false },
    checkboxLabel: { type: String, default: "Don't ask me again" },
    checkboxDisabled: { type: Boolean, default: false },
    checkboxChecked: { type: Boolean, default: false },
    buttonCloseText: { type: String, default: 'Close' },
    showContactCsm: { type: Boolean, default: false },
    csmSentenceText: { type: String },
    csmLinkText: { type: String },
    csmSentenceTextEnd: { type: String },
    csmChatMessage: { type: String },
    primaryBtnType: {
      type: String,
      default: 'primary',
      required: false,
    },
    titleColorClass: {
      type: String,
      default: '-blue',
      required: false,
    },
  },
};
</script>
